<template>
  <div>
    <van-form style="position: relative">
      <div class="">
        <van-search
          v-model:value="productName"
          show-action
          placeholder="请输入商品名称或商品条码"
          @search="search"
          @clear="clear"
        >
          <template #action>
            <div @click="search">搜索</div>
          </template>
        </van-search>
      </div>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="已显示全部"
        @load="getList(true)"
      >
        <div v-for="(item, index) in tableData" :key="index" class="card">
          <div class="card-row top">
            <div class="name">{{ item.productName }}</div>
            <van-tag :type="getStatus(item).type">{{
              getStatus(item).text
            }}</van-tag>
          </div>
          <div class="card-row">
            <span>批次号：{{ item.lotCode || "-" }}</span>
            <span>入库时间：{{ item.createTime || "-" }}</span>
          </div>
          <div class="card-row">
            <span>有效期：{{ item.shelfLife || "-" }}</span>
            <span>剩余天数：{{ item.numberOfDaysExpired ?? "-" }}</span>
          </div>
          <div class="card-row">
            <span>外部编码：{{ item.externalCode || "-" }}</span>
          </div>
          <div class="card-row">
            <span>库存数量：{{ item.stockNum || 0 }}</span>
            <van-button
              size="mini"
              type="primary"
              plain
              v-if="Number(item.numberOfDaysExpired) < 0"
              @click="handleLossOut(item)"
              >一键报损出库</van-button
            >
          </div>
        </div>
      </van-list>
    </van-form>
  </div>
</template>
<script>
import {
  queryBydic,
  queryWarningProductList,
  lossStockOut,
} from "../../service/api/product";
import { Dialog, Toast } from "vant";
export default {
  name: "index",
  data() {
    return {
      productName: "",
      loading: true,
      finished: false,
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
      totalPage: 1,
      tableData: [],
      showPicker: false,
      key: "",
      alertLevelColumns: [],
    };
  },
  mounted() {
    queryBydic().then((res) => {
      // YJYJ EJYJ SJYJ
      this.alertLevelColumns = res.data.map((item) => {
        item.text =
          item.code === "YJYJ"
            ? "一级预警"
            : item.code === "EJYJ"
            ? "二级预警"
            : item.code === "SJYJ"
            ? "三级预警"
            : "";
        return item;
      });
    });
    this.getList();
  },
  methods: {
    openPicker(key) {
      this.showPicker = true;
      this.key = key;
    },
    // 一键报损出库
    handleLossOut(item) {
      Dialog.confirm({
        title: "确认弹窗",
        message: "确认一键报损出库？系统只扣减库存，实物请安排处理。",
      })
        .then(async () => {
          const res = await lossStockOut({
            lotId: item.lotCode,
          });
          Toast.success(res.msg || "报损出库成功");
          this.search();
        })
        .catch(() => {});
    },
    getStatus(item) {
      const days = Number(item.numberOfDaysExpired);
      if (days < 0) {
        return { text: "已过期", type: "danger" };
      } else {
        return { text: "已临期", type: "warning" };
      }
    },
    clear() {
      this.productName = "";
      this.search();
    },
    search() {
      this.pageIndex = 1;
      this.finished = false;
      this.tableData = [];
      this.getList();
    },
    getList(load) {
      if (load) {
        this.pageIndex++;
      }
      this.loading = true;
      const params = Object.assign(
        {},
        { productName: this.productName },
        {
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
        },
      );
      queryWarningProductList(params)
        .then((res) => {
          this.tableData = load
            ? this.tableData.concat(res.data.datas)
            : res.data.datas;
          this.loading = false;
          this.totalCount = res.data.totalCount;
          this.totalPage = res.data.totalPage;
          if (this.pageIndex >= this.totalPage) {
            this.finished = true;
          }
        })
        .catch(() => {
          this.loading = false;
          this.finished = true;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.card {
  background: #fff;
  margin: 8px 10px;
  padding: 10px 12px;
  border-radius: 8px;

  .card-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    color: #666;

    & + .card-row {
      margin-top: 8px;
    }

    &.top .name {
      font-size: 15px;
      font-weight: 500;
      color: #333;
    }
  }
}
</style>
